import script from "./ValentineQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./ValentineQuestion.vue?vue&type=script&setup=true&lang=js"

import "./ValentineQuestion.vue?vue&type=style&index=0&id=27ad6e58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ad6e58"]])

export default __exports__